// extracted by mini-css-extract-plugin
module.exports = {"compact-download-button":"SrDownloadButton--compact-download-button--297iP","highlightYellowFadeIn":"SrDownloadButton--highlightYellowFadeIn--2W65W"};